import { Column } from '@bidalihq/ui';

export default function NotFullColumn ({ children, ...props }) {
  return (
    <Column className="mx-auto" span={[12, 8]} start={[1, 3]} end={[12, 9]} {...props}>
      {children}
    </Column>
  );
}
